<template>
  <a-dialog ref="dialog" name="edit_customer_informations" :loading="loading" @open="opened" @close="closed">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <a-customer-form
        ref="form"
        @valid="onFormValid"
        @submit="submit">
      </a-customer-form>
    </div>
    <span slot="actions">
      <v-btn color="blue darken-1" :disabled="!form.valid" text @click="submit">
        {{ $t('actions.edit') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'EditCustomerInformationsDialog',
  data () {
    return {
      loading: '',
      form: {
        valid: false,
      }
    }
  },
  methods: {
    onFormValid (valid) {
      this.form.valid = valid
    },
    opened () {
      this.$nextTick(() => {
        this.$refs.form.$on('message', text => this.loading = text)
      })
    },
    closed () {
      this.$reset()
      this.$refs.form.$off('message')
    },
    async submit () {
      try {
        const message = await this.$refs['form'].submit()
        this.$ui.success(message)
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    },
  }
}
</script>

<i18n>
{
	"en": {
		"title": "Billing information"
	},
	"es": {
		"title": "Información de facturación"
	},
	"fr": {
		"title": "Coordonnées de facturation"
	},
	"it": {
		"title": "Informazioni di fatturazione"
	},
	"pt": {
		"title": "Informações de faturação"
	},
	"pl": {
		"title": "Dane do faktury"
	}
}
</i18n>

